<template>
  <vx-card class="mb-4 ">
    <vs-row class="flex" :class="align">
      <vs-col class="flex-wrap" :class="size==='mobile'?'':'w-auto'" vs-align="center" style="display: inline-flex;">
        <slot></slot>
      </vs-col>
      <vs-col class="flex w-auto" vs-align="flex-end" style="margin-left:auto;">
        <vs-button color="secondary" @click="handleSearch">{{$t("search.검색")}}</vs-button>
      </vs-col>
    </vs-row>
  </vx-card>
</template>

<script>
export default {
  name: 'SearchNav',
  props:{
    align:String,
    size:String
  },
  methods:{
    handleSearch () {
      this.$emit('handleSearch')
    }
  }
}
</script>

<style scoped>

</style>
